import { mapGetters, mapMutations } from "vuex";
import APICaller from "./APICaller";
import { loadLegacyFinderStocks } from '@/features/stockchart/api/legacyFinderRepository';
import { legacyCollectionStatus } from '@/features/stockchart/models/legacyCollectionStatus';
export default {
    data: () => ({ stockLoadIntervals: [] }),
    beforeDestroy() { this.stockLoadIntervals.forEach(clearInterval); },
    computed:{
      ...mapGetters(['_g_SelectedTicker','is_mobile_device', '_g_is_loading_stocks', '_g_portfolio_id_selected']),
    },
    methods: {
      ...mapMutations(['setStocks','setSelectedTicker', 'setIsLoadingStocks']),

      tickerChangerWatcher: function() {
        let last_ticker_search_by_user = '';
        var self = this;

        this.stockLoadIntervals.push(setInterval(function() {
          var ticker_search_by_user = window.sessionStorage.getItem('ticker_search_by_user');
          if (ticker_search_by_user && ticker_search_by_user != '' && last_ticker_search_by_user != ticker_search_by_user) {
            last_ticker_search_by_user = ticker_search_by_user;
            self.$router.push('/app/graficador-dinamico/ticker/' + ticker_search_by_user);
          }
        }, 1000));
      },

      getStocks: function(callback){
        legacyCollectionStatus.error = '';
        // Only require portfolio id for routes that actually need it
        const routeType = this.$route && this.$route.params && this.$route.params.param1;
        const needsPortfolio = ['waitings', 'open-positions', 'all-values'].includes(routeType);
        if (needsPortfolio && (this._g_portfolio_id_selected == undefined || this._g_portfolio_id_selected == null)) {
          return [];
        }

        this.setIsLoadingStocks(true);
        this.stocks = null;
        const generation = this.stockLoadRevision = (this.stockLoadRevision || 0) + 1;
        const requestedRoute = this.$route.fullPath;
        if (!routeType) {
          return this._getDefaultStocks().then(() => { if (typeof callback === 'function' && !this._isDestroyed && generation === this.stockLoadRevision && requestedRoute === this.$route.fullPath) callback(); });
        }
        let request;
        if(this.$route.params.param1 == "platinum" && !this.filters){
          request = this._getPlatinumValues();
        }else if(this.$route.params.param1 == "last-ipos"){
          request = this._getStocksIPO();
        }else if(this.$route.params.param1 == "best-bullish-values"){
          var bullish_timing = this.$route.params.param2
          request = this._getStocksBestBullish(bullish_timing);
        }else if(this.$route.params.param1 == "best-sectors"){
          var sector_timing = this.$route.params.param2
          request = this._getStocksBestSectors(sector_timing);
        }else if(this.$route.params.param1 == "hot-values"){
          var hot_value_timing = this.$route.params.param2;
          request = this._getStocksHotValues(hot_value_timing);
        }else if(this.$route.params.param1 == "compatibility"){
          request = this._getStocksCompatibility();
        }
        else if (this.$route.params.param1 == "exchange") {
          var exchange_index = this.$route.params.param2;
          request = this._getStocksExchange(exchange_index);
        }
        else if (this.$route.params.param1 == "sector") {
          var sector = this.$route.params.param2;
          request = this._getStocksSector(sector);
        }
        else if (this.$route.params.param1 == 'ticker') {
          var ticker = this.$route.params.param2;
          request = this._getStockByTickerName(ticker);
        }
        else if (this.$route.params.param1 == "favorites") {
          var folder = this.$route.params.param2;
          request = this._getStocksFavorites(folder);
        }
        else if(this.$route.params.param1 == "waitings"){
          let idc = this.$route.params.param2;
          request = this._getWaitingValues(idc);
        }else if(this.$route.params.param1 == "open-positions"){
          let idc = this.$route.params.param2;
          request = this._getOpenPositionsValues(idc);
        }else if(this.$route.params.param1 == "all-values"){
          let idc = this.$route.params.param2;
          request = this._getAllValues(idc);
        }else if(this.$route.params.param1 == "twin-souls"){
          let index = this.$route.params.param2;
          request = this._getTwinValues(index);
        }else if(this.$route.params.param1 == "informe"){
          let informeSlug = this.$route.params.param2;
          request = this._getStocksInforme(informeSlug);
        }
        // Treat single segment route as a direct ticker if not a known category
        else if (this.$route.params.param1) {
          const knownCategories = [
            'platinum','last-ipos','best-bullish-values','best-sectors','hot-values','compatibility',
            'exchange','sector','ticker','favorites','waitings','open-positions','all-values','twin-souls','informe'
          ];
          const maybeTicker = this.$route.params.param1;
          if (knownCategories.indexOf(maybeTicker) === -1) {
            request = this._getStockByTickerName(maybeTicker);
          } else {
            request = this._getDefaultStocks();
          }
        }
        else{
          request = this._getDefaultStocks();
        }   

        return Promise.resolve(request).then(() => {
          if (this._isDestroyed || generation !== this.stockLoadRevision || requestedRoute !== this.$route.fullPath) return;
          this.stocks = this.stocks || [];
          this.setStocks(this.stocks);
          this.setIsLoadingStocks(false);
          if (typeof callback === 'function') callback();
        });
      },

      _collectionHandlers(success, failure) {
        const route = this.$route.fullPath, portfolio = this._g_portfolio_id_selected, generation = this.stockLoadRevision;
        const identity = () => JSON.stringify([this.$store && this.$store.getters._g_User && this.$store.getters._g_User.uid, localStorage.getItem('user_access_token')]);
        const user = identity();
        const current = () => !this._isDestroyed && identity() === user && this.$route.fullPath === route && this._g_portfolio_id_selected === portfolio && this.stockLoadRevision === generation;
        return [new APICaller.SuccessHandler(response => { if (current()) return success.successCallback(response); }),
          new APICaller.FailureHandler(failure.errorCode, failure.errorDescription, error => {
            if (!current()) return;
            this.stocks = [];
            legacyCollectionStatus.error = 'No se pudieron cargar los valores. Reintenta la búsqueda desde Filtros.';
            if (failure.hasCallback) failure.errorCallback(error);
          })];
      },
      _getCollectionCall(url, success, failure, config) {
        const handlers = this._collectionHandlers(success, failure);
        return this._getAPICall(url, handlers[0], handlers[1], config);
      },
      _postCollectionCall(url, params, success, failure, config) {
        const handlers = this._collectionHandlers(success, failure);
        return this._postAPICall(url, params, handlers[0], handlers[1], config);
      },

      _getDefaultStocks: async function () {
        const route = this.$route.fullPath;
        const identity = () => JSON.stringify([this.$store.getters._g_User && this.$store.getters._g_User.uid, localStorage.getItem('user_access_token'), this._g_portfolio_id_selected, this.$route.params]);
        const scope = identity();
        try {
          const classicDesktop = this.$route.path.indexOf('/app/graficador-dinamico') === 0 && window.innerWidth >= 901;
          const stocks = await loadLegacyFinderStocks(scope, classicDesktop);
          if (scope !== identity()) return;
          if (this._isDestroyed || this.$route.fullPath !== route) return;
          this.stocks = stocks;
          this.setSelectedTicker(stocks.find(stock => stock.ticker === (this._g_SelectedTicker || {}).ticker) || stocks[0] || {});
          this._setStocks(); this._url_stock(); this.setIsLoadingStocks(false);
        } catch (error) {
          if (this._isDestroyed || scope !== identity() || error.code === 'STALE_QUERY' || this.$route.fullPath !== route) return;
          legacyCollectionStatus.error = 'No se pudieron cargar los valores. Reintenta la búsqueda desde Filtros.';
          this.stocks = []; this.setStocks([]); this.setSelectedTicker({}); this.setIsLoadingStocks(false);
          this.$vueOnToast.pop('error', 'No se pudieron cargar los valores. Reintenta desde Filtros.');
        }
      },
  
      _getStocksCompatibility: function(){
        let success = response =>{
          this.stocks = response.data;
          var queryString = window.location.search;
          var urlParams = new URLSearchParams(queryString);
          var anuncioParam = urlParams.get('active_ticker');
          this.setSelectedActiveTicker(this.stocks[0]);
          
          for(var i=0; i < this.stocks.length; i++){
            if(this.stocks[i].ticker == anuncioParam){
              this.setSelectedActiveTicker(this.stocks[i]);
            }
          }
        } 
  
        var url = '';
  
        if(this.$route.query.currency != undefined && this.$route.query.currency != ''){
          url = '/api/v1/stock-finder/stocks/compatibility?currency=' + this.$route.query.currency;
        }
        else{
          url = '/api/v1/stock-finder/stocks/compatibility';
        }
  
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('008', 'Error recuperando valores.');

        return this._getCollectionCall(url, successHandler, failureHandler);
      },
  
      _getStocksFavorites: function(folder) {
        let success = response => {
          this.stocks = response.data;
  
          this.setSelectedActiveTicker(this.stocks[0]);
        }
  
        let url = '/api/v1/stock-finder/stocks/favoritos/' + folder;
  
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('009', 'Error recuperando valores favoritos.');
        const apiCallConfig = {timeoutMs: 0};

        return this._getCollectionCall(url, successHandler, failureHandler, apiCallConfig);
      },

      _getStocksDescriptionSearch: function(search_term) {
        let success = response => {
          this.stocks = response.data;
          if(this.stocks.length != 0){
            this.setSelectedActiveTicker(this.stocks[0]);
          }

          this._setStocks();
          this._url_stock();
        }
  
        let url = '/api/v1/stock-finder/stocks/busqueda-descripcion';

        let params = new URLSearchParams();
        params.append('search_term', search_term);

        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('233', 'Error en la búsqueda.');

        return this._postCollectionCall(url, params, successHandler, failureHandler);
      },
  
      _getStocksIPO() {
        let success = response => {
          this.stocks = response.data;
  
          this.setSelectedActiveTicker(this.stocks[0]);
          this._setStocks();
          this._url_stock();
        }
  
        let url = '/api/v1/stock-finder/last-ipos'
  
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('010', 'Error recuperando valores.');

        return this._getCollectionCall(url, successHandler, failureHandler);
      },
  
      _getStocksBestBullish(bullish_timing) {
        let success = response =>{
          this.stocks = response.data;
  
          this.setSelectedActiveTicker(this.stocks[0]);
          this._setStocks();
          this._url_stock();
        }
  
        let url = '/api/v1/stock-finder/best-bullish-values/' + bullish_timing;
  
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('011', 'Error recuperando valores.');
        const apiCallConfig = {timeoutMs: 0};

        return this._getCollectionCall(url, successHandler, failureHandler, apiCallConfig);
      },
      
      _getStocksBestSectors(sector_timing) {
        const success = response => { this.stocks = response.data; this.setSelectedActiveTicker(this.stocks[0]); this._setStocks(); this._url_stock(); };
        return this._getCollectionCall('/api/v1/stock-finder/best-sectors/' + sector_timing, new APICaller.SuccessHandler(success), new APICaller.FailureHandler('012', 'Error recuperando valores.'));
      },
      _getStocksHotValues(hot_value_timing) {
        let success = response => {
          this.stocks = response.data;
  
          this.setSelectedActiveTicker(this.stocks[0]);
          this._setStocks();
          this._url_stock();
        }
  
        let url = '/api/v1/stock-finder/hot-values/' + hot_value_timing
  
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('013', 'Error recuperando valores.');

        return this._getCollectionCall(url, successHandler, failureHandler);
      },

      _url_stock() {
        if (this._g_SelectedTicker && this._g_SelectedTicker.chart != undefined) {
          if (this._g_SelectedTicker.chart.url != undefined) {
              //return  this._g_SelectedTicker.ticker; descomentamos estas dos lineas y comentamos la de abajo
              this.url_stock = process.env.VUE_APP_API + '/stockchart?t=23&s=' + this._g_SelectedTicker.chart.url;
          }else{
              this.url_stock = process.env.VUE_APP_API + '/stockchart?t=23&s=aapl';
              //return 'AAPL'; descomentamos esta linea y comentamos la de arriba
          }
        }
      },
  
      _getStocksExchange(exchange_index) {
        
        let success = response => {
          this.stocks = response.data;
          
  
          this.setSelectedActiveTicker(this.stocks[0]);
          this._setStocks();
          this._url_stock();
        }

        let url = '/api/v1/stock-finder/stocks/index/' + exchange_index;
  
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('014', 'Error recuperando valores.');

        return this._getCollectionCall(url, successHandler, failureHandler);
      },
  
      _getStocksSector(sector) {
        let success = response => {
          this.stocks = response.data;
  
          this.setSelectedActiveTicker(this.stocks[0]);
          this._setStocks();
          this._url_stock();
        }
  
        let params = new URLSearchParams();
        params.append('sector', sector);
  
        let url = '/api/v1/stock-finder/stocks/sector';
  
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('234', 'Error recuperando stocks.');

        return this._postCollectionCall(url, params, successHandler, failureHandler);
      },
  
      _getStockByTickerName(ticker) {
        let success = response => {
          const stocks = response.data || [];

          if (stocks.length == 0) {
            var that = this;
            let success2 = response => {
              const stock = response.data;

              if (!stock) {
                that.stocks = [];
                that.setSelectedTicker({});
                that._setStocks();
                that._url_stock();
                return;
              }

              stock.chart = stock.chart || {
                image: '',
                url: '/stockchart?&s=' + ticker,
              };
              stock.isEureker = false;

              that.stocks = [stock];
              that.setSelectedActiveTicker(that.stocks[0]);
              that._setStocks();
              that._url_stock();
            }
            let url2 = '/api/v1/stock-finder/stocks/symbol-without-entry/' + ticker;
  
            const successHandler = new APICaller.SuccessHandler(success2);
            const failureHandler = new APICaller.FailureHandler('015', 'Error recuperando valores no eurekers.', () => {
              that.stocks = [];
              that.setSelectedTicker({});
              that._setStocks();
              that._url_stock();
            });

            return this._getCollectionCall(url2, successHandler, failureHandler);
          }

          this.stocks = stocks;

          // Prefer selecting the exact ticker requested if present in response
          if (this.stocks && this.stocks.length > 0) {
            const desired = (ticker || '').toUpperCase();
            const match = this.stocks.find(s => (
              (s && (s.ticker || s.id || s.symbol)) && (s.ticker || s.id || s.symbol).toUpperCase() === desired
            ));
            this.setSelectedActiveTicker(match || this.stocks[0]);
          }
          this._setStocks();
          this._url_stock();
        }
  
        let url = '/api/v1/stock-finder/stocks/symbol/' + ticker;
  
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('016', 'Error recuperando valores.');

        return this._getCollectionCall(url, successHandler, failureHandler);
      },
  
  
      _getPlatinumValues: function(){
        let success = (response) => {
          if(response.data.length == 0){
            this.$vueOnToast.pop('info', "Platino", "Porfavor cambie a Platino para utilizar esta funcionalidad");
            this.setMenuSelectionOut(4);
          }else{
            this.stocks = response.data;                
            this.setSelectedActiveTicker(this.stocks[0]);
            this._setStocks();
            this._url_stock();
          }              
        };
  
        let url = "/api/v1/stock-finder/stocks/platinum";
  
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('017', 'Error recuperando valores platino.');

        return this._getCollectionCall(url, successHandler, failureHandler);
      },
      _getWaitingValues: function(idc) {
        let that = this;
        let success = response => {
          let result = that._getStockFinderPortfolioTickers(response.data);
          return that._getStocksFromArray(result);

        }
         
        let url = '/api/v1/portfolio/waitings/' + idc + '?stock_finder_only=1';
  
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('161.2', 'Error recuperando valores en espera.');
        const apiCallConfig = {loadingOverlay: false};

        return this._getCollectionCall(url, successHandler, failureHandler, apiCallConfig);
      
      },
      _getOpenPositionsValues: function(idc) {
        let success = response => {
          let result = this._getStockFinderPortfolioTickers(response.data);
          return this._getStocksFromArray(result);

        }
         
        let url = '/api/v1/portfolio/open_positions/' + idc;
  
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('161.3', 'Error recuperando valores en espera.');
        const apiCallConfig = {loadingOverlay: false};

        return this._getCollectionCall(url, successHandler, failureHandler, apiCallConfig);
      
      },
      _getAllValues: function(idc){
        let success = response => {
          let result = this._getStockFinderPortfolioTickers(response.data);
          return this._getStocksFromArray(result);

        }
         
        let url = '/api/v1/portfolio/all-tickers/' + idc;
  
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('161.3', 'Error recuperando valores en espera.');
        const apiCallConfig = {loadingOverlay: false};

        return this._getCollectionCall(url, successHandler, failureHandler, apiCallConfig);

      },

      _getStockFinderPortfolioTickers: function(tickers) {
        let result = [];
        tickers = tickers || [];

        tickers.forEach(element => {
          if (element && element.ticker && !element.is_external && element._type != 'ManualWatchlist' && element.status != 'pending_setup') {
            result.push(element.ticker);
          }
        });

        return result;
      },

      _getTwinValues: function(index){
        let success = response => {
          let all_twins = response.data;
          let pre_stocks = all_twins[index]["stocks"];
          let result = pre_stocks.map(obj => obj.name);
          this._getStocksFromArray(result)
        }
  
        let url = '/api/v1/widgets/get-twin-souls';
  
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('319', 'Error recuperando stocks.');

        return this._getCollectionCall(url, successHandler, failureHandler);
      },

      _getStocksFromArray: function(result){
        if (!result || result.length == 0) {
          this._clearStocksFromArray();
          return;
        }

        let params = new URLSearchParams();
        params.append('array_tickers', result);
        let success = response => {
          this.stocks = response.data || [];
          if (this.stocks.length != 0) {
            this.setSelectedActiveTicker(this.stocks[0]);
          }
          else {
            this.setSelectedTicker({});
            this.url_stock = '';
          }
          this._setStocks();
          this._url_stock();
        }

        let url = "/api/v1/stock-finder/stocks/symbols/array"

        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('313', 'Error recuperando valores por array.');
        const apiCallConfig = {timeoutMs: 60000};

        return this._postCollectionCall(url, params, successHandler, failureHandler, apiCallConfig);
      },

      _clearStocksFromArray: function() {
        this.stocks = [];
        this.setSelectedTicker({});
        this.url_stock = '';
        this._setStocks();
      },
      
      _getStocksInforme(informeSlug) {
        let success = response => {
          this.stocks = response.data;

          this.setSelectedActiveTicker(this.stocks[0]);
          this._setStocks();
          this._url_stock();
        }

        let url = '/api/v1/stock-finder/informe/' + informeSlug;

        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('075', 'Error recuperando valores del informe.');

        return this._getCollectionCall(url, successHandler, failureHandler);
      },
      
      setSelectedActiveTicker(ticker) {
        if(this.is_mobile_device){
          if(this._g_SelectedTicker != {} && this._g_SelectedTicker != undefined){
            //hace bucle
            let flag = false;
            this.stocks.forEach(element => {
              if(element.ticker == this._g_SelectedTicker.ticker){
                flag = true;
                this.setSelectedTicker(this._g_SelectedTicker);
              }
            })
            if(!flag){
              this.setSelectedTicker(ticker);
            }
        
          }else{
            this.setSelectedTicker(ticker);
          }
        }
        else{
          this.setSelectedTicker(ticker);  
        }
      },

      _setStocks(){
        this.setStocks(this.stocks)
      }
    }
}
